import {NgClass, NgStyle}                                          from '@angular/common';
import {AfterViewInit, Component, inject}                          from '@angular/core';
import {GlobalDataTypesDict, HkitRecordLogIntf, HkitRecordSumType} from '@djsharkk/logr-types';
import {IconName}                                                  from '@fortawesome/fontawesome-common-types';
import {ChartLogDayComponent}                                      from '../../lib/logr-charts/visualisations/chart-log-day/chart-log-day.component';
import {ChartMoodDayComponent}                                     from '../../lib/logr-charts/visualisations/chart-mood-day/chart-mood-day.component';
import {ChartBreakdownDayComponent}                                from '../../lib/logr-charts/visualisations/chart-rize-day/chart-breakdown-day.component';
import {ChartVapeSumComponent}                                     from '../../lib/logr-charts/visualisations/chart-vape-sum/chart-vape-sum.component';
import {DataFactoryService}                                        from '../../lib/logr-services/data/data-factory.service';
import {UiCardComponent}                                           from '../../lib/logr-ui/comps/ui/ui-card/ui-card.component';
import {UiNumberFormatterService}                                  from '../../lib/logr-ui/utils/ui-number-formatter.service';

export type HkitDashTypes = Extract<
	HkitRecordSumType,
	| 'dietary_water'
	| 'time_in_daylight'
	| 'step_count'
	| 'apple_exercise_time'
>
export type TrendIconName = Extract<
	IconName,
	| 'minus'
	| 'arrow-up'
	| 'arrow-down'
>

export interface DashItemIntf {
	valCurrent: string;
	trend: TrendIconName;
	valYesterday: string;
}

export type DashItemType<T extends string> = {
	[key in T]: DashItemIntf
}

@Component({
			   selector   : 'app-view-home',
			   imports    : [
				   UiCardComponent,
				   ChartLogDayComponent,
				   ChartVapeSumComponent,
				   ChartBreakdownDayComponent,
				   ChartMoodDayComponent,
				   NgClass,
				   NgStyle
			   ],
			   templateUrl: './view-home.component.html',
			   styleUrl   : './view-home.component.css'
		   })
export class ViewHomeComponent implements AfterViewInit {
	svcDataFactory = inject(DataFactoryService);
	svcUiNumberFormatter = inject(UiNumberFormatterService)


	hkitList: HkitDashTypes[] = [
		'dietary_water',
		'time_in_daylight',
		'step_count',
		'apple_exercise_time'
	]

	hkitVals: DashItemType<HkitDashTypes> = {
		dietary_water      : {
			valCurrent  : '0',
			valYesterday: '0',
			trend       : 'minus'
		},
		time_in_daylight   : {
			valCurrent  : '0',
			valYesterday: '0',
			trend       : 'minus'
		},
		step_count         : {
			valCurrent  : '0',
			valYesterday: '0',
			trend       : 'minus'
		},
		apple_exercise_time: {
			valCurrent  : '0',
			valYesterday: '0',
			trend       : 'minus'
		}
	}

	public ngAfterViewInit() {

		this.svcDataFactory.svcDataHkit
			.getRecordsSum()
			.subscribe(records => {
				this.hkitVals.dietary_water = this.buildUnitItem(records);
				this.hkitVals.time_in_daylight = this.buildMinsItem(records);
				this.hkitVals.step_count = this.buildQtyItem(records);
				this.hkitVals.apple_exercise_time = this.buildMinsItem(records);
			})


		this.svcDataFactory.svcDataVape
			.getRecordsSum()
			.subscribe(data => {
				// if (data.length > 0) {
				// 	this.sumItemsR.text = `${data[0].overall.qtyTotal.toFixed()}mg`
				// }
			})
	}

	buildUnitItem(records: HkitRecordLogIntf[]): DashItemIntf {
		const recs = this.svcDataFactory.svcDataHkit.getRecordsByType(records, 'dietary_water')
		return {
			valCurrent  : `${recs[0].qty.toFixed()}${recs[0].unit}`,
			valYesterday: `${recs[1].qty.toFixed()}${recs[1].unit}`,
			trend       : this.trendBuilder(recs[0].qty, recs[1].qty)
		}
	}

	buildMinsItem(records: HkitRecordLogIntf[]): DashItemIntf {
		const recs = this.svcDataFactory.svcDataHkit.getRecordsByType(records, 'time_in_daylight')
		return {
			valCurrent  : this.svcUiNumberFormatter.minsToClock(recs[0].qty),
			valYesterday: this.svcUiNumberFormatter.minsToClock(recs[1].qty),
			trend       : this.trendBuilder(recs[0].qty, recs[1].qty)
		}
	}

	buildQtyItem(records: HkitRecordLogIntf[]): DashItemIntf {
		const recs = this.svcDataFactory.svcDataHkit.getRecordsByType(records, 'step_count')
		return {
			valCurrent  : `${recs[0].qty.toFixed()}`,
			valYesterday: `${recs[1].qty.toFixed()}`,
			trend       : this.trendBuilder(recs[0].qty, recs[1].qty)
		}
	}

	trendBuilder(t: number, y: number): TrendIconName {
		return t > y ? 'arrow-up' : t < y ? 'arrow-down' : 'minus'
	}

	protected readonly GlobalDataTypesDict = GlobalDataTypesDict;
}
